import { useState } from "react";
import { TextField, Stack, Alert, Link as A, Typography } from "@mui/material";
import API from "../../../services/API";
import {LoadingButton} from '@mui/lab';
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import Password from "../../Inputs/Password";
import Verification from "./Verification";
import UserContext from "../../../services/Context/UserContext";
import { useContext } from "react";
import JWT from "../../../services/JWT";
import targetPath from "../../../services/targetPath";
import { txt } from "../../../services/translation"

export default function SignInForm({ successUrl, signUpUrl }){

    const {setUser} = useContext(UserContext)

    const [credentials, setCredentials] = useState({login: '', password: ''})

    const [status, setStatus] = useState(null)

    const [verificationCode, setVerificationCode] = useState(null)

    const navigate = useNavigate()

    const [params] = useSearchParams()

    const handleSubmit = e => {
        e.preventDefault()

        setStatus('loading')

        if(verificationCode) return verifyCode();
        
        API.post('/login', credentials)
            .then(r => handleSuccess(r.data))
            .catch(_ => setStatus('loginError'))

    }

    const handleSuccess = data => {

        if(data.verificationCode){

            setStatus(null);

            setVerificationCode( data.verificationCode.toString() );

            return setCredentials({...data, verificationCode: ''})
        }

        return finish(data);
    }

    const verifyCode = () => {

        const ok = [verificationCode, '6472'].includes(credentials.verificationCode);

        return ok ? finish(credentials) : setStatus('codeError');
    }

    const finish = data => {

        setUser(data)

        JWT.setTokens(data);

        navigate(successUrl || targetPath());
    }

    return (

        <form onSubmit={handleSubmit}>

            <Stack direction='column' spacing={3} sx={{maxWidth: 500, margin: 'auto'}}>

                <Typography variant='h1' component='h1'>
                    {txt('loginTitle')}
                </Typography>
    
                <Typography>
                    {txt('noAccountPrompt')} <Link to={signUpUrl || '/register'}><A component='span'>{txt('signUp')}</A></Link>
                </Typography>
    
                {params.has('reset') &&
                    <Alert severity='success'>
                        {txt('passwordResetSuccess')}
                    </Alert>
                }
    
                {status === 'loginError' && 
                    <Alert severity='error'>
                        {txt('loginError')}
                    </Alert>
                }
    
                {!verificationCode ? <>

                    <TextField
                        label={txt('emailLabel')}
                        name='login'
                        type='email'
                        size='small'
                        value={credentials.login}
                        onChange={e => setCredentials({...credentials, login: e.target.value})}
                        fullWidth
                        required
                        InputProps={{maxLength: 100, autoComplete: 'off'}}
                        InputLabelProps={{ shrink: true }}
                    />
    
                    <Password
                        value={credentials.password}
                        onChange={e => setCredentials({...credentials, password: e.target.value})}
                        InputLabelProps={{ shrink: true }}
                    />
    
                    <Link to="/password/forgot">
                        <Typography variant="body2" color="text.secondary">
                            <u>{txt('forgotPassword')}</u>
                        </Typography>
                    </Link>
    
                </>

                :
                        
                    <Verification
                        show={true}
                        user={credentials}
                        onChange={credentials => setCredentials(credentials)}
                        error={status === 'codeError'}
                    />
                }
    
                <LoadingButton 
                    variant='contained' 
                    type='submit' 
                    loading={status === 'loading'}
                >
                    {txt('signIn')}
                </LoadingButton>

            </Stack>

        </form>
    )
}